import { i18n } from '../services/i18n.js';
import { auth } from '../services/auth.js';
import { icon } from '../services/icons.js';

export const LoginView = (container) => {
  container.innerHTML = `
    <div style="flex:1; display:flex; align-items:center; justify-content:center; padding: 40px 24px;">
      <div class="card" style="width:100%; max-width:400px; text-align:center; padding:40px;">
        <div style="margin-bottom:20px;">
          <img src="assets/logo.png" alt="Heart150 Logo" style="width: 80px; height: 80px; object-fit: contain; filter: drop-shadow(0 0 8px rgba(255, 59, 92, 0.5));" />
        </div>
        <h2 style="font-size:28px; font-weight:800; margin-bottom:12px; letter-spacing:-0.5px;">Heart150</h2>
        <p style="color: var(--color-text-secondary); font-size:14px; margin-bottom:32px;">
          Đăng nhập bằng tài khoản Google để bắt đầu tạo những khoảnh khắc bùng nổ.
        </p>
        
        <button id="googleLoginBtn" class="btn btn-secondary" style="width:100%; display:flex; justify-content:center; gap:12px; padding: 14px; font-size:15px; border-color: rgba(255,255,255,0.15);">
          ${icon('key')}
          ${i18n.t('login_btn')}
        </button>
      </div>
    </div>
  `;

  // Bind Login Trigger
  container.querySelector('#googleLoginBtn').addEventListener('click', () => {
    auth.login('/#/dashboard');
  });
};
